import { z } from "zod";

/**
 * Use this if you need to loop through all the options
 */
export const QuoteStatusValues = [
  "NOT_SUBMITTED",
  "PENDING_SUBMISSION",
  "SUBMITTED",
  "REJECTED_BEFORE_SUBMISSION",
] as const;
/**
 * Use this if you need to zod parse it
 */
export const QuoteStatusSchema = z.enum(QuoteStatusValues);
/**
 * Use this if you need to use the literal value
 */
export const QuoteStatus = QuoteStatusSchema.enum;
/**
 * Use this if you need to use the type
 */
export type QuoteStatus = (typeof QuoteStatusValues)[number];

export const QuoteStatusDisplayName: Record<QuoteStatus, string> = {
  NOT_SUBMITTED: "Not submitted",
  PENDING_SUBMISSION: "Submission pending",
  SUBMITTED: "Submitted",
  REJECTED_BEFORE_SUBMISSION: "Rejected before submission",
};
